export default {
  // General TR5
  'tr5.odometer': 'Odomètre',
  'tr5.year': 'Année',
  'tr5.nav.menu.editProfile': 'Modifier profil',
  'tr5.nav.menu.accounting': 'Comptabilité',
  'tr5.nav.menu.reports': 'Rapports',
  'tr5.nav.menu.settings': 'Paramètres',
  'tr5.nav.menu.chat': 'Discutez avec nous',
  'tr5.nav.menu.support': 'Soutien',
  'tr5.nav.menu.logout': 'Fermer la session',
  'tr5.nav.menu.switchUser': "Remplacer l'utilisateur",
  'tr5.poweredBy': 'Propulsé par',
  'tr5.trademark':
    '© {year} TradeRev® est une marque de commerce de NthGen Software®. Tous droits réservés.',
  'tr5.select': 'Sélectionner',
  'tr5.na': 'N/D',

  'tr5.controls.more': 'Plus',
  'tr5.controls.sendToClosing': 'Envoyer à l’encan sous Fermeture',
  'tr5.controls.parkVehicle': 'Stationner le véhicule',
  'tr5.controls.editVehicle': 'Modifier le véhicule',
  'tr5.controls.auctionInDGN': 'Encan à même le Groupe concessionnaires',
  'tr5.controls.sendToLost': 'Envoyer en mode Perdu',

  // General VDP
  'vdp.asis': 'Tel quel',
  'vdp.highbid': 'Meilleure Offre!',
  'vdp.outbid': 'Dépassé',
  'vdp.floorMet': 'Plancher atteint',
  'vdp.floorPrice': 'Prix Plancher',
  'vdp.hasFloorPrice': 'Plancher non atteint',
  'vdp.closeToFloorPrice': 'Près du prix plancher',
  'vdp.auctionEnded': 'Encan terminé',
  'vdp.pendingEnded': 'Terminé',
  'vdp.closingEnded': 'Fermeture Terminée',
  'vdp.headerViews': '114 vues',
  'vdp.rateInfo': 'Info Tarif.',
  'vdp.transportPromoOn': 'Promotion en cours!',
  'vdp.transportPromoInfoLong': 'Infos sur tarifs promotionnels',
  'vdp.transportValueEstimated': 'estimé',
  'vdp.seller.detailsShownToBuyer': "Informations divulguées à l'acheteur",

  // Pending Closing VDP
  'vdp.closing.buyer.disclaimer':
    "En plaçant une offre, vous confirmez que vous avez examiné la page de détails du véhicule et le rapport sur l'historique du véhicule.",
  'vdp.pending.buyer.button.reply': 'Répondre',
  'vdp.pending.buyer.button.startNegotiation': 'Commencer les négotiations',
  'vdp.pending.buyer.button.viewNegotiation': 'Voir les négotiations',
  'vdp.pending.buyer.button.view': 'VISUALISER',
  'vdp.pending.buyer.declined': 'Refusé',
  'vdp.pending.buyer.label.buyerCounter': 'Votre contreproposition',
  'vdp.pending.buyer.label.buyerFirm': 'Ferme à',
  'vdp.pending.buyer.label.buyerOffer': 'Votre offre',
  'vdp.pending.buyer.label.finalAskingPrice': 'Prix final demandé',
  'vdp.pending.buyer.label.newAsking': 'Nouveau prix demandé',
  'vdp.pending.buyer.label.nowInActive': 'Maintenant sous Enchère active',
  'vdp.pending.buyer.label.nowInUpcoming': 'Maintenant sous À Venir',
  'vdp.pending.buyer.label.sellerCounter': 'Nouvelle contreproposition',
  'vdp.pending.buyer.label.sellerOffer': 'Nouveau prix demandé',
  'vdp.pending.buyer.label.sentToSecondBidder': 'Envoyer au 2e offrant',
  'vdp.pending.buyer.label.yourOffer': 'Votre offre',
  'vdp.pending.buyer.label.yourTopBid': 'Votre meilleure offre',
  'vdp.pending.seller.button.reply': 'Répondre',
  'vdp.pending.seller.button.sendToClosing': 'Envoyer à l’encan sous Fermeture',
  'vdp.pending.seller.button.startNegotiation': 'Commencer les négotiations',
  'vdp.pending.seller.button.viewNegotiation': 'VISUALISER',
  'vdp.pending.seller.label.buyerCounter': 'Nouvelle contreproposition',
  'vdp.pending.seller.label.buyerFirm': 'Acheteur ferme à',
  'vdp.pending.seller.label.buyerOffer': 'Nouvelle offre',
  'vdp.pending.seller.label.finalAskingPrice': 'Votre prix final demandé',
  'vdp.pending.seller.label.sellerCounter': 'Vous demandez',
  'vdp.pending.seller.label.sellerOffer': 'Vous demandez',
  'vdp.pending.tiah.invitedCustomer': 'Client invité',
  'vdp.pending.tiah.createdAt.dateExists.invitedCustomer':
    "Vous avez envoyé à votre client une invitation à l'Échange à Domicile et il a garé son échange le ",
  'vdp.pending.tiah.createdAt.emptyDate.invitedCustomer':
    'Vous avez envoyé une invitation à l’Échange à Domicile à votre client et son véhicule est stationné.',

  // Confirmation Modals
  'vdp.confirmation.title.sameDealership':
    'Quelqu’un à votre concessionnaire est déjà le meilleur offrant sur ce véhicule.',
  'vdp.confirmation.title.sameDealershipMessage':
    'Les enchérisseurs de même concessionnaires n’iront pas en Fermeture ensemble. Désirez-vous quand même soumettre une offre?',
  'vdp.confirmation.title.sameDealerGroup':
    'Un autre membre de votre groupe de concessionnaires est actuellement le premier enchérisseur pour ce véhicule.',
  'vdp.confirmation.msg.submitBid':
    'Souhaitez-vous toujours soumettre votre offre?',
  'vdp.confirmation.title.bidSeemsHigh':
    'Votre offre de {bidAmount} semble trop élevée.',
  'vdp.confirmation.title.startingBidSeemsHigh':
    'Votre offre de départ de {bidAmount} semble être élevée. ',
  'vdp.confirmation.msg.confirmBidAmount':
    'Souhaitiez-vous saisir une offre de départ de {bidAmount}? Si tel est le cas, vous pouvez continuer ci-dessous.',
  'vdp.confirmation.title.proxySeemsHigh':
    'Votre offre maximale de {proxyAmount} semble élevée.',
  'vdp.confirmation.msg.confirmProxyAmount':
    'Souhaitiez-vous saisir une offre maximale de {proxyAmount}? Si tel est le cas, vous pouvez continuer ci-dessous.',
  'vdp.confirmation.yesBid': 'Oui, miser',

  // Toaster
  'toaster.dismiss.message': 'Rejeter',

  // Toaster Error Messages
  'vdp.error.startingBidLow':
    'L’offre de départ que vous avez présentée est trop faible. Saisissez une offre de départ d’au moins {minBidAmount}',
  'vdp.error.bidTooLow':
    'Le montant de votre offre est trop faible. Veuillez saisir un montant supérieur à la meilleure offre actuelle.',
  'vdp.error.startingBidLargerThanProxy':
    'Votre offre de départ est plus élevée que votre offre maximale (proxy). Veuillez saisir une offre de départ inférieure au montant de votre offre maximale (proxy).',
  'vdp.error.wrongBidIncrement':
    'Votre offre était dans le mauvais incrément. Veuillez enchérir sur ce véhicule par tranches de {quickBidIncrement}',
  'vdp.error.noStartingBid':
    "Veuillez saisir un montant pour l'offre de départ.",
  'vdp.error.noBid': 'Veuillez saisir un montant d’enchère.',
  'vdp.error.noProxy': 'Veuillez saisir une offre maximale (proxy).',
  'vdp.error.noProxyNoStartingBid':
    "Vous n’avez pas saisi une offre maximale (proxy). Veuillez saisir un montant de départ ainsi qu'un montant maximal (proxy).",
  'vdp.error.proxyTooLow':
    "L'offre maximale que vous avez saisi est trop faible. Entrez une offre maximale d’au moins {minProxyAmount}",
  'vdp.error.wrongProxyIncrement':
    'Votre offre maximale était dans le mauvais incrément. Veuillez saisir une offre maximale sur ce véhicule par tranches de {proxyIncrement}',
  'vdp.error.placingBid': "Nous n'avons pu placer l’offre sur cette vente.",
  'vdp.error.placingProxy':
    "Nous n'avons pu placer l’offre maximale sur cette vente.",
  'vdp.error.general':
    'Un problème est survenu lors de la récupération de toutes les données de cette vente, veuillez patienter ou essayer d’actualiser la page',

  // Toaster Success Messages
  'vdp.success.bidPlaced': 'Votre offre a bien été placée.',
  'vdp.success.proxySet':
    'Votre offre maximale de {proxyAmount} a été fixée. Vous pouvez la modifier si vous le souhaitez.',
  'vdp.success.vinCopied': 'NIV copié dans le presse-papiers',

  // VDP Header
  'vdp.launchTime.active.today': 'Lancé aujourd’hui à {time}',
  'vdp.launchTime.yesterday': 'Lancé hier à {time}',
  'vdp.launchTime.upcoming.today': "Lancement aujourd'hui a {time}",
  'vdp.launchTime.upcoming.today.sale': "Aujourd'hui au {time}",
  'vdp.launchTime.tomorrow': 'Lancement demain à {time}',
  'vdp.launchTime.tomorrow.sale': 'Demain à {time}',
  'vdp.launchTime.future': 'Lancera le {date} à {time}',
  'vdp.launchTime.future.sale': '{date} à {time}',
  'vdp.launchTime.past': 'Lancé le {time}',
  'vdp.expirationTime.pending.today':
    'Période En Attente se termine aujourd’hui à {time}',
  'vdp.expirationTime.pending.tomorrow':
    'Période En Attente se termine demain à {time}',
  'vdp.expirationTime.pending.future':
    'Période En Attente se termine le {date} à {time}',
  'vdp.watch': 'Regarder',
  'vdp.watched': 'Regardé',
  'vdp.close': 'FERMER',
  'vdp.share': 'PARTAGÉ LE VÉHICULE',

  // VDP Overview
  'vdp.overview.vin': 'NIV',
  'vdp.overview.copyVin': 'Copier le NIV:',
  'vdp.overview.transmissionDriveTrain': 'Groupe motopropulseur',
  'vdp.overview.dateExpected': 'Date prévue',
  'vdp.overview.specsFeatures': 'Spécifications et caractéristiques complètes',
  'vdp.overview.make': 'Marque',
  'vdp.overview.model': 'Modèle',
  'vdp.overview.trim': 'Série',
  'vdp.overview.color': 'Couleur extérieure/intérieure',
  'vdp.overview.seats': 'Sièges',
  'vdp.overview.vehicleFeatures': 'Caractéristiques du véhicule',
  'vdp.overview.viewAll': 'Tout afficher',
  'vdp.overview.media.overview': 'Aperçu',
  'vdp.overview.media.disclosure': "Divulgation d'une information",
  'vdp.overview.media.videos': 'Vidéos',
  'vdp.overview.media.open': 'Multimédia ouvert',
  'vdp.overview.tradeId': 'Numéro du Véhicule',
  'vdp.overview.rateInfo.noQuote': 'Aucun devis disponible',
  'vdp.overview.rateInfo.promoRateInfo':
    'Infos sur les tarifs de transport promotionnels',
  'vdp.overview.rateInfo.rateInfo': 'Infos tarifs de transport',

  // VDP Multimedia
  'vdp.multimedia.title': 'Multimédia',
  'vdp.multimedia.disclosureImages': 'Images de divulgation',
  'vdp.multimedia.overviewImages': 'Aperçu des images',
  'vdp.multimedia.video': 'Vidéo',
  'vdp.multimedia.header.esc': 'Appuyez sur la clé <esc>esc</esc> pour ',
  'vdp.multimedia.interiordamage': 'Dommage Intérieur',
  'vdp.multimedia.exteriordamage': 'Dommage Extérieur',
  'vdp.multimedia.other': 'Autre',

  // VDP Bid
  'vdp.bid.tradeState.active': 'Actif',
  'vdp.bid.tradeState.upcoming': 'À Venir',
  'vdp.bid.tradeState.pending': 'En Attente',
  'vdp.bid.tradeState.closing': 'Fermeture',
  'vdp.bid.tradeState.arrived': 'Arrivé',
  'vdp.bid.tradeState.delivered': 'Livré',
  'vdp.bid.proxyAmount': 'Offre maximale (proxy)',
  'vdp.bid.startingBid': 'Offre de départ',
  'vdp.bid.auctionLaunched': 'Encan démarré',
  'vdp.bid.bidAmount': 'Montant de l’enchère',
  'vdp.bid.currentBidAmount': 'Montant de l’offre actuelle',
  'vdp.bid.beFirst': 'Soyez le premier à enchérir!',
  'vdp.bid.noBids': "Pas d'offre pour le moment",
  'vdp.bid.timeLeft.countdown.seconds': '{seconds}s',
  'vdp.bid.timeExtended': 'Prolongée',
  'vdp.bid.under30s': 'Moins de 30s',
  'vdp.bid.left': 'restantes',
  'vdp.bid.timeLeft': 'Moins de {time} {unit}',
  'vdp.bid.timeLeft.countdown': '{minutes}min {seconds}s',
  'vdp.bid.timeLeft.countdown.minutes': '{minutes}min',
  'vdp.bid.under1Min': 'Moins de 1 min',
  'vdp.bid.pendingVHR':
    'Le rapport d’historique de ce véhicule est toujours en attente.',
  'vdp.bid.floorPrice': 'Prix plancher: {floorPrice}',
  'vdp.bid.fullHistory': 'Historique complet',
  'vdp.bid.fullBidHistory': 'Historique complet des offres',
  'vdp.bid.numberOfBids':
    '{numberOfBids, plural, one {# offre} other {# offres}}',
  'vdp.bid.yourBid': 'Votre enchère',
  'vdp.bid.placedDaysAgo':
    '{daysAgo, plural, one {Il y a # jour} other {il y a # jour(s)}}',
  'vdp.bid.placedHoursAgo':
    '{hoursAgo, plural, one {Il y a # heure} other {il y a # heure(s)}}',
  'vdp.bid.placedMinutesAgo':
    '{minsAgo, plural, one {Il y a # min} other {il y a # minute(s)}}',
  'vdp.bid.button.bid': 'Enchérir',
  'vdp.bid.button.placeBid': 'Miser',
  'vdp.bid.button.setProxy': 'FIXER OFFRE MAXIMALE',
  'vdp.bid.currentBid': 'Montant de l’offre',
  'vdp.bid.button.setProxyAmount': 'FIXER PROXY {proxyAmount}',
  'vdp.bid.button.setProxyAndBidAmount':
    'Enchérir {bidAmount} et fixer votre offre maximale {proxyAmount}',
  'vdp.bid.button.editProxy': "Modifier l'offre maximale",
  'vdp.bid.button.editProxyAmount': 'Modifier l’offre maximale a {proxyAmount}',
  'vdp.bid.button.quick.min.bid': 'Offre min',
  'vdp.bid.proxyMessage':
    "Offre maximale (proxy) : Nous enchérissons juste assez pour que vous restiez le meilleur enchérisseur, jusqu'à concurrence de votre offre maximale.",
  'vdp.bidModal.form.setProxy': 'Fixer le montant de l’enchère par procuration',
  'vdp.bidOverview.form.setProxy': 'Fixer offre maximale',
  'vdp.bid.editBidAmount': 'Éditer',
  'vdp.bid.selectDealership.prefix': 'En tant que:',
  'vdp.bid.selectDealership.invalidDealership':
    'Choisir un concessionnaire pour continuer',
  'vdp.bid.default': '(Défaut)',
  'vdp.bid.switchDealerships':
    "Le fait de changer de concessionnaire peut modifier les devis de transport. Veuillez confirmer le coût estimé avant d'enchérir.",

  // VDP Inner Nav
  'vdp.innerNav.overview': 'Aperçu',
  'vdp.innerNav.condition': 'État',
  'vdp.innerNav.history': 'Historique',
  'vdp.innerNav.transportSeller': 'Transport et vendeur',
  'vdp.innerNav.research': 'Recherche',

  // VDP Conditions Disclosures
  'vdp.conditions.title': 'État',
  'vdp.conditions.thirdPartyInspected': 'Inspecté par un tiers',
  'vdp.conditions.seeChecklist': 'Voir la liste de contrôle',
  'vdp.conditions.nothingReported': 'Rien n’a été signalé',
  'vdp.conditions.inspectionDealerNotes':
    'Inspection et notes du concessionnaire',
  'vdp.conditions.alwaysReadNotes':
    'Toujours lire et examiner toutes les notes avant d’enchérir.',
  'vdp.conditions.noNotes': 'Aucune note fournie.',

  // VDP History
  'vdp.history.title': 'Résumé de l’historique',
  'vdp.history.alwaysViewReport':
    'Toujours consulter le rapport {reportType} avant d’enchérir',
  'vdp.history.waitingVHR': 'En attente du rapport d’historique du véhicule.',
  'vdp.history.viewButton': 'Voir',
  'vdp.history.noneReported': 'Aucun signalé',

  // VDP Transport details
  'vdp.transport.Details': 'Détails de transport',
  'vdp.transport.Disclosures': 'Informations de transport',
  'vdp.transport.NothingReported': 'Rien n’a été signalé',
  'vdp.transport.NotAvailable': 'Indisponible',
  'vdp.transport.NotDriveable':
    'Non-éligible pour conduite par chauffeurs{delimeter}',
  'vdp.transport.NotDriveableDiscTitle':
    'Ce véhicule n’est pas en état d’être opéré.',
  'vdp.transport.IsOversized': 'Est surdimensionné',
  'vdp.transport.DateExp': 'Date prévue',
  'vdp.transport.Estimate': 'Devis de transport',
  'vdp.transport.PromoOn': 'Promotion en cours!',
  'vdp.transport.PromoInfo': 'Informations sur la promotion',
  'vdp.transport.VehicleLocation': 'Emplacement du véhicule',
  'vdp.transport.estimateNotAvailable':
    "Le devis de transport n'est pas disponible pour ce véhicule en ce moment.",
  'vdp.transport.estimate':
    'Transport {startsWithVowel, select, true {d’} other {de }}{city}, {province}, à votre emplacement: ',
  'vdp.transport.hasDateExpectedExceededLimit':
    'La date prévue est à plus de {dateExpectedDaysLimit} jours du lancement',
  'vdp.transport.estimateWithStreet':
    'à {street}, {city}, {province}, {postalCode}',

  // VDP Seller Info
  'vdp.seller.heading': 'Informations du vendeur',
  'vdp.seller.qa': 'Questions et réponses',
  'vdp.seller.qaButton': 'Ouvrir Q&R',
  'vdp.seller.dealer': 'Concessionnaire vendeur',
  'vdp.seller.answers':
    '{chatCount, plural, one {# question et réponse} other {# questions et réponses}}',
  'vdp.seller.ratings': '({ratingsCount, plural, one {# avis} other {# avis}})',
  'vdp.seller.network': 'Réseau:',
  'vdp.seller.payments': 'Paiements acceptés',
  'vdp.seller.noRatings': '(Pas encore d’évaluation)',

  // Research
  'vdp.research.heading': 'Recherche',
  'vdp.research.subheading':
    'Données des 90 derniers jours provenant du marché TradeRev pour des véhicules similaires',
  'vdp.research.average': 'Prix moyen',
  'vdp.research.highest': 'Élevée',
  'vdp.research.lowest': 'Bas',
  'vdp.research.researchVin': 'Ouvrir ce NIV dans la recherche TradeRev',
  'vdp.research.autoniq': 'Rechercher ce véhicule dans Autoniq',
  'vdp.research.autoniq.short': 'Recherche dans Autoniq',
  'vdp.research.no.marketguide.data.part1':
    'Il n’y a pas assez de données de marché de ventes en gros pour ',
  'vdp.research.no.marketguide.data.part2':
    'l’année, la marque, le modèle et la série ',
  'vdp.research.no.marketguide.data.part3':
    'de ce véhicule. Trouvez des véhicules comparables en allant sous le Guide du Marché et en étendant la plage d’années, ou en choisissant davantage de types de série.',

  // VDP Share Retail
  'vdp.retail.price.placeholder': 'Entrer prix client',
  'vdp.retail.description.placeholder': 'Entrer la description',
  'vdp.retail.share': 'Partager ce véhicule avec un client',
  'vdp.retail.shareUrl': "Partager l'URL de ce véhicule",
  'vdp.retail.message':
    "Créez une vue conviviale de cette page que vous contrôlez pour l'envoyer à un client potentiel.",
  'vdp.retail.link': 'Créer un lien client',
  'vdp.retail.noCarfax.title': 'Rapport CARFAX pas encore prêt',
  'vdp.retail.noCarfax.message':
    "Vous ne pouvez pas créer de lien client tant que le Rapport CARFAX n'a pas été ajouté à ce listage",
  'vdp.retail.vhr': "Rapport d'historique du véhicule",
  'vdp.retail.vhr.carfax':
    'Voir ci-dessous pour un lien vers le rapport CARFAX Canada de ce véhicule.',
  'vdp.retail.kilometres': 'Kilomètres',
  'vdp.retail.transmission': 'Boîte de vitesses',
  'vdp.retail.engine': 'Moteur',
  'vdp.retail.drivetrain': 'Chaîne cinématique',
  'vdp.retail.fuelType': 'Type de carburant',
  'vdp.retail.seats': 'Sièges',
  'vdp.retail.exteriorInterior': 'Couleur extérieure/intérieure',

  // Footer
  'vdp.footer.findMore': 'Trouvez d’autres véhicules sous {tradeState}',
  'vdp.footer.backTo': 'Retour à {tradeState}',

  // Mini VDP
  'mini.vdp.nothing.selected.heading': 'Aucun Véhicule sélectionné.',
  'mini.vdp.nothing.selected.subheading':
    'Choisir un véhicule à la gauche pour y voir les details et les mises.',

  // Retail VDP
  'retail.customization.heading': 'Partager ce véhicule avec un client',
  'retail.customization.subheading':
    "Créez une vue conviviale de cette page que vous contrôlez pour l'envoyer à un client potentiel. Vous devez vous assurer que toutes les informations concernant le véhicule et son état sont transmises avec précision à tout client potentiel.",
  'retail.customization.form.title': 'Personnaliser le véhicule',
  'retail.customization.price': 'Prix client (facultatif)',
  'retail.customization.price.disclaimer': 'Taxes et immatriculations en sus',
  'retail.customization.media.vehicle.heading': 'Images de véhicules',
  'retail.customization.media.select': 'Tout sélectionner',
  'retail.customization.media.deselect': 'Tout déselectionner',
  'retail.customization.media.damage.heading': 'Inclure des images de dommages',
  'retail.customization.media.video.heading':
    'Inclure des vidéos avec audio (Veuillez examiner les vidéos pour vous assurer que le contenu est approprié pour votre client)',
  'retail.customization.description.heading':
    'Description de la fiche du véhicule (facultatif)',
  'retail.customization.dealerDetails.heading':
    'Détails du concessionnaire (facultatif)',
  'retail.customization.dealerDetails.name': 'Nom du vendeur',
  'retail.customization.dealerDetails.email': 'Courriel du vendeur',
  'retail.customization.dealerDetails.phone': 'Téléphone du vendeur',
  'retail.customization.dealerDetails.inventory':
    "Lien vers l'inventaire d'occasion du concessionnaire",
  'retail.customization.dealerDetails.name.placeholder': 'Nom',
  'retail.customization.dealerDetails.email.placeholder':
    'exemple@courriel.com',
  'retail.customization.dealerDetails.phoneNumber.placeholder': '123 456-789',
  'retail.customization.dealerDetails.inventory.placeholder':
    'URL du site du concessionnaire',
  'retail.customization.create.description':
    "La création de la page ouvrira un nouvel onglet dans votre navigateur. Si vous voulez apporter une correction ou faire plus d'une page, revenez ici et créez-en une autre.",
  'retail.customization.create.button': 'CRÉER UNE PAGE',
  'retail.create.loading.heading':
    'Nous sommes en train de créer votre page ...',
  'retail.create.loading.sub.heading': "Cela ne devrait prendre qu'une minute.",
  'retail.create.loading.cancel': 'ANNULER',
  'retail.customization.input.error':
    'Veuillez corriger toutes les erreurs sur la page avant de pouvoir continuer',
  'retail.customization.image.input.error':
    'Vous devez avoir sélectionné au moins une image du véhicule pour créer une page de détails du véhicule conviviale pour le client',
  'retail.customization.footer':
    "Veuillez noter qu'il incombe au concessionnaire de se conformer à toutes les lois provinciales applicables à la vente au détail de véhicules automobiles, y compris toute obligation de divulgation.",
  'retail.city': 'Ville',
  'retail.highway': 'Autoroute',
  'retail.features': 'Caractéristiques',
  'retail.description': 'Description',
  'retail.directions.link': 'Coordonnées',
  'retail.salesperson.label': 'Vendeur',
  'retail.seeMore.title': 'Pas intéressé par ce véhicule ?',
  'retail.seeMore.button': "Voir plus d'inventaire",
  'retail.tiah.title': "Avez-vous un véhicule d'échange ?",
  'retail.tiah.text':
    'Envoyez à <name>{dealership}</name> les renseignements sur votre véhicule et nous laisserons des centaines de concessionnaires faire des offres sur celui-ci, afin que vous puissiez obtenir un prix équitable dans le confort de votre domicile.',
  'retail.tiah.button': 'Créer ma liste de véhicule',
  'retail.url.copied': 'Lien copié dans le presse-papiers',
  'retail.footer':
    "Nth Gen Software Inc, opérant sous le nom de OPENLANE, n'est pas responsable de l'exactitude de l'état ou des options disponibles sur le véhicule affiché ci-dessus. OPENLANE est un marché de gros et seuls les concessionnaires automobiles enregistrés peuvent acheter des véhicules sur OPENLANE. Par conséquent, OPENLANE ne doit pas être interprété comme ayant conclu un contrat avec vous ou tout autre consommateur et n'est pas responsable des représentations, garanties ou communications faites par un concessionnaire de véhicules automobiles enregistrés à vous ou à tout autre consommateur. Veuillez noter qu'il incombe au concessionnaire de se conformer à toutes les lois provinciales applicables à la vente au détail de véhicules automobiles, y compris toute obligation de divulgation. Veuillez contacter votre concessionnaire pour tous les détails.",
  'retail.error': "Cette page n'existe plus",
  'retail.tiah.learn.more.text':
    "Faites-leur savoir que vous êtes à l'origine de ce message en ajoutant la marque de votre concessionnaire.",
  'retail.tiah.learn.more': 'En savoir plus',

  // Nav Search Bar
  'list.nav.searchbar.placeholder': 'Rechercher',
  'list.nav.searchbar.modal.searchbar.title': 'Rechercher dans ',
  'list.nav.searchbar.modal.searchbar.title.omp.sell': 'Rechercher sous Vendre',
  'list.nav.searchbar.modal.search.selling': 'Vente',
  'list.nav.searchbar.modal.search.buying': 'Achat',
  'list.nav.searchbar.modal.searchbar.placeholder':
    'Rechercher par année, marque, modèle, série, couleur, NIV complet ou partiel ou numéro de véhicule.',
  'list.nav.searchbar.modal.searchbar.placeholder.omp.sell':
    'Rechercher un véhicule sous Vendre',
  'list.nav.searchbar.modal.searchButton': 'RECHERCHER',
  'list.nav.searchbar.modal.closeButton': 'FERMER',
  'list.nav.searchbar.modal.hint.sKey':
    'Vous pouvez appuyer sur la touche <sKey> S </sKey> pour ouvrir la recherche, ',
  'list.nav.searchbar.modal.hint.escKey':
    'et la touche <escKey> S </escKey> pour le fermer.',
  'list.nav.searchbar.modal.search.history': 'VOS RECHERCHES RÉCENTES',
  'list.nav.searchbar.modal.search.results':
    '{resultsMatching, plural, =0 {0 {state} résultat total} one {# {state} résultat total} other {# {state} résultats totaux}} correspondant à ’{inputString}’ sous {context}',
  'list.nav.searchbar.modal.search.end': 'Fin des résultats correspondants',
  'list.nav.searchbar.modal.similar.trades':
    'Véhicules similaires qui pourraient vous intéresser:',
  'list.nav.search.no.results':
    'Aucune correspondance exacte trouvée sous {state}.',
  'list.nav.search.no.results.try':
    'Rechercher par année, marque, modèle, ensemble de garnitures, couleur, NIV complet ou partiel ou ID déchange.',
  'list.currently.in': 'Actuellement en',
  'list.results.total': 'total',
  'list.nav.searchbar.modal.search.results.loading':
    'Chargement des résultats correspondant à ’{inputString}’ dans {context}',

  // List card
  'list.launchTime.active.today': "Lancé dans Actif aujourd'hui à {time}",
  'list.launchTime.upcoming.today': "Active aujourd'hui à {time}",
  'list.launchTime.tomorrow': 'Actif demain à {time}',
  'list.launchTime.future': 'Actif {date} à {time}',
  'list.launchTime.past': 'Lancé à Actif le {date} à {time}',

  // Layout
  'layout.list': 'Liste',
  'layout.grid': 'Grille',

  // Sorting
  'list.sorting.label': 'Triés',
  'list.sorting.endingSoonest': 'Finissant le plus tôt',
  'list.sorting.activeSoonest': 'Actif le plus tôt',
  'list.sorting.recentlyListed': 'Récemment listé',
  'list.sorting.mileageLowHigh': 'Kilométrage : faible à élevé',
  'list.sorting.mileageHighLow': 'Kilométrage : élevé à faible',
  'list.sorting.yearNewOld': 'Année : neuf à ancien',
  'list.sorting.yearOldNew': 'Année : ancien à neuf',

  // Filters
  'list.filters.headertext': 'Filtres',
  'list.filters.clear': 'EFFACER',
  'list.filters.mysavedfilters': 'Mes filtres enregistrés',
  'list.filters.save': 'Sauvegarder',
  'list.filters.add.logo': 'Ajouter le logo',
  'list.filters.edit.details': 'Modifier les détails',
  'list.filters.overwrite': 'REMPLACER',
  'list.filters.from': 'du',
  'list.filters.away': 'à {distance} {unit}',
  'list.filters.inStock': 'En inventaire seulement',
  'list.filters.floorMet': 'Prix plancher atteint uniquement',
  'list.filters.franchiseDealers': 'Concessionnaires franchisés seulement',
  'list.filters.year.before': 'Avant {year}',
  'list.filters.allSelected': 'Tous sélectionnés',
  'list.filters.numberSelected': '{number} sélectionnés',
  'list.filters.apply': 'Appliquer',
  'list.filters.only': 'Uniquement',
  'list.filters.makes': 'Marques',
  'list.filters.models': 'Modèles',
  'list.filters.allMakes': 'Toutes les marques sélectionnées',
  'list.filters.allModels': 'Tous les modèles sélectionnés',
  'list.filters.allFuelTypes': 'Tous les types de carburant sélectionnés',
  'list.filters.searchMakes': 'Rechercher des marques',
  'list.filters.searchModels': 'Rechercher des modèles',
  'list.filters.transmission': 'Transmission',
  'list.filters.fuelType': 'Type de carburant',
  'list.filters.province': `{provinceCount, plural, one {Province} other {Provinces}}`,
  'list.filters.distance': 'Distance',
  'list.filters.distance.any': 'Toutes distance',
  'list.filters.conditions.asIs': 'Masquer les véhicules Tels Quels',
  'list.filters.conditions.any.history':
    "Masquer les véhicules avec des antécédents d'accidents",
  'list.filters.conditions.accident.amount':
    'Masquer les véhicules avec des accidents de plus de 3 000 $',
  'list.filters.isEditing': '(modification en cours)',
  'list.filters.notification.label':
    'Recevoir des notifications pour ce filtre enregistré',
  'list.filters.notification.success':
    'Nous vous informerons lorsque des véhicules correspondant à ce filtre enregistré seront disponibles.',
  'list.filters.notification.error':
    'Une erreur est survenue lors de l’activation de cette notification de filtre. Veuillez réessayer.',
  'list.filters.networks.all': 'Tous les réseaux',
  'list.filters.save.confirmation.title': 'Créer un nouveau filtre enregistré.',
  'list.filters.apply.confirmation.title':
    'Remplacer votre filtre enregistré ?',
  'list.filters.apply.body.message':
    'Cela mettra à jour ’{name}’ avec l’ensemble de filtres actuellement sélectionné.',
  'list.filters.save.confirmation.msg':
    'Nous enregistrerons vos filtres actuellement sélectionnés afin que vous puissiez y accéder à nouveau rapidement lorsque vous en aurez besoin.',
  'list.filters.save.confirmation.newName':
    'Nom du nouveau filtre enregistré (max 25 caractères)',
  'list.filters.save.confirmation.placeholder': 'Choisissez un nom distinct',
  'list.filters.save.custom.title':
    'Les notifications de filtre sont désactivées.',
  'list.filters.save.custom.msg':
    'Souhaitez-vous être informé des véhicules correspondant aux filtres enregistrés ? Si vous répondez oui, nous activerons vos notifications de filtre.',
  'list.filters.save.notificationsOff.title':
    'Toutes les notifications sont désactivées.',
  'list.filters.save.notificationsOff.msg':
    'Si vous souhaitez être informé des véhicules correspondant à vos filtres enregistrés, accédez à Paramètres > Notifications et choisissez votre préréglage de notifications.',
  'list.filters.provinces.all': 'Toutes les provinces sélectionnées',
  'list.filters.provinces.some': '{number} provinces sélectionnées',
  'list.filters.delete.header': 'Supprimer ce filtre enregistré ?',
  'list.filters.delete.body':
    'Cela supprimera le filtre {filterTitle} de votre liste de filtres enregistrés.',
  'list.filters.delete.cancel': 'ANNULER',
  'list.filters.delete.delete': 'SUPPRIMER',
  'list.filters.save.success':
    "Création d'un nouveau filtre sauvegardé avec succès",
  'list.filters.save.error':
    'Une erreur est survenue lors de la création de ce filtre sauvegardé',
  'list.filters.updateNotification.success':
    'Mise à jour des paramètres de notification',
  'list.filters.updateNotification.error':
    'Une erreur est survenue lors de la mise à jour des paramètres de notification',
  'list.filters.save.noFilterName': 'Veuillez entrer un nom de filtre',
  'list.filters.save.duplicateFilter':
    'Le nom de filtre ’{name}’ existe déjà, veuillez choisir un autre nom pour votre filtre.',

  // Filter pills
  'list.filters.pills.distance': 'à {number} km ',
  'list.filters.pills.mileageRange': '{range} km',

  // Refresh list button
  'list.button.refresh': 'Actualiser la liste',
  'list.button.refresh.text.active': 'Plusieurs encans sont terminés.',
  'list.button.refresh.text.upcoming':
    'Plusieurs véhicules ont été lancés dans Actif.',

  // List menu
  'list.options.impound': 'Mettre ce véhicule en fourrière',
  'list.options.unimpound': 'Retirer le véhicule de votre liste de fourrière',
  'list.options.removeVehicle': 'Retirer ce véhicule',
  'list.options.deleteVehicle': 'Supprimer ce véhicule',
  'list.options.launchToActive': 'Lance ce véhicule dans Actif',
  'list.options.impound.success':
    "Le véhicule d'échange a été ajouté avec succès à votre liste de fourrière",
  'list.options.impound.error':
    'Une erreur est survenue lors de la mise en fourrière de ce véhicule',
  'list.options.unimpound.success':
    "L'échange a été retiré avec succès de votre liste de fourrière",
  'list.options.unimpound.error':
    'Une erreur est survenue lors du retrait de la mie en fourrière de ce véhicule',

  // Modals
  'modal.yes': 'Oui',
  'modal.ok': 'D’accord',
  'modal.noThanks': 'Non, merci',
  'modal.cancel': 'Annuler',
  'modal.confirmation.loading': 'Chargement ...',
  'modal.confirmation.confirmYourBid.title':
    'Avez-vous lu la page de détails et le rapport d’historique de ce véhicule?',
  'modal.confirmation.confirmYourBid.description':
    'Nous ne poserons cette question qu’une seule fois pour ce véhicule - d’autres mises ne susciteront pas ce message.',
  'modal.submit': 'Soumettre',

  // Badges
  'badges.volumeSellerBadge': 'Vendeur de volume',
  'badges.volumeSellerBadge.description':
    "L'un des vendeurs les plus importants",
  'badges.hasDisclosures': 'A des divulgations',
  'badges.inStock': 'En stock',
  'badges.QA': 'Q&R',

  // Tooltips
  'tooltips.isFloorPriceMet':
    'Le prix plancher a été atteint, la vente de ce véhicule est garantie.',
  'tooltips.hasFloorPrice':
    'Si le prix plancher du vendeur est atteint, la vente de ce véhicule sera garantie.',
  'tooltips.isCloseToFloorPrice':
    "L'offre actuelle est presque au prix plancher du vendeur - continuez à enchérir!",

  // Pagination
  'pagination.prev': 'PRÉC.',
  'pagination.next': 'SUIVANT',
  'pagination.title': 'Page {currentPage} de {totalPages}',

  // List Sale Event
  'list.saleEvent.end.of.event': 'FIN DE L’ÉVÉNEMENT',
  'list.saleEvent.event.continued':
    "L'ÉVÉNEMENT CONTINUE À LA PAGE SUIVANTE ...",
  'list.saleEvent.start.of.event': "Aller au début de l'événement",
  'list.saleEvent.dealer.event': 'ÉVÉNEMENT DU CONCESSIONNAIRE',
  'list.saleEvent.dealer.event.continued':
    "L'ÉVÉNEMENT DU CONCESSIONNAIRE S'EST POURSUIVI...",
  'list.saleEvent.vehicles': 'véhicules',
  'list.saleEvent.hosted.by': 'Organisé par',
  'list.saleEvent.network': 'Réseau',
  'list.saleEvent.active': 'Actif',

  // List Header, Footer & Empty state
  'list.header.vehicles': 'véhicule(s) au total',
  'list.header.buy.upcoming':
    'Ces véhicules seront bientôt mis aux enchères. Prévisualisez les véhicules et placer vos offres maximales.',
  'list.header.buy.active':
    'Enchérissez sur les véhicules lors de notre encan en direct.',
  'list.header.buy.pending.decision.heading':
    'En Attente de la décision du vendeur / Valeur totale de l’offre {totalBid}',
  'list.header.buy.pending.decision.subheading':
    'Le vendeur décidera de vendre ou non le véhicule.',
  'list.header.sell.pending.decision.heading':
    "Décision requise | {totalBid} valeur totale d'offres",
  'list.header.sell.pending.decision.subheading':
    'Fermez cet entente ou essayez de négocier avec le meilleur enchérisseur.',
  'list.header.paymentsOnHold': 'Paiement en suspens',
  'list.header.paymentsOnHold.caption':
    'Voir véhicules avec paiements dus sous Arrivé et Livré',
  'list.modal.pending.park.confirm.title':
    "Terminer l'encan et passer en mode Stationné",
  'list.header.amount.vehicles':
    '{amount} {amount, plural, =0 {véhicule} =1 {véhicule} other {véhicules}}',
  'list.modal.pending.park.confirm.message':
    "Cela mettra fin à l'encan et à toute possibilité de négocier avec les deux premiers enchérisseurs.",
  'list.modal.pending.park.confirm.confirm': 'STATIONNER LE VÉHICULE',
  'list.modal.pending.park.confirm.success':
    'Le véhicule a été Stationnée avec succès',
  'list.modal.pending.park.confirm.error':
    'Un problème est survenu au moment de Stationné le véhicule',
  'list.modal.pending.moveToClosing.confirm.message':
    "Vous ne pouvez pas envoyer ce véhicule à l’encan sous Fermeture puisqu’il n’y a qu’un seul enchérisseur. Acceptez l'offre finale de {acv} $ et déplacez ce véhicule vers Gagné?",
  'list.controls.selectNetwork': 'Choisir un réseau',
  'list.modal.pending.auctionToDealerGroup.in.nego.title':
    'Vous ne pouvez pas lancer une enchère en Réseau Groupe Concessionnaires',
  'list.modal.pending.auctionToDealerGroup.in.nego.message':
    'Vous avez entamé une négociation, vous ne pouvez donc pas lancer une enchère de Groupe Concessionnaires.',
  'list.modal.pending.auctionToDealerGroup.title':
    'Envoyer au Groupe Concessionnaires.',
  'list.modal.pending.auctionToDealerGroup.message':
    "Envoyez ce véhicule à votre Réseau de Groupes Concessionnaires. Lorsque l'enchère sera terminée, vous pourrez déterminer laquelle fermer.",
  'list.modal.pending.auctionToDealerGroup.selectNetwork.label':
    ' Réseau Groupe Concessionnaires (obligatoire)',
  'list.modal.pending.auctionToDealerGroup.startingBidAmount.label':
    'Définir le prix de départ (obligatoire)',
  'list.modal.pending.auctionToDealerGroup.confirm.button': "DÉBUTER L'ENCAN",
  'list.modal.pending.auctionToDealerGroup.confirm.success':
    'Véhicule envoyé en Encan Actif dans le {dealerNetwork}.',
  'list.modal.pending.auctionToDealerGroup.confirm.error':
    'Un problème est survenu lors de la mise aux enchères du véhicule dans le Groupe Concessionnaires que vous avez sélectionné.',
  'list.modal.pending.auctionToDealerGroup.confirm.startBid.error':
    "Désolé, votre offre de départ ne peut pas dépasser l'offre la plus élevée de votre véhicule en Réseau Ouvert.",
  'list.modal.pending.moveToLost.confirm.title':
    'Terminer Encan et marquer véhicule Perdu',
  'list.modal.pending.moveToLost.confirm.message':
    "Cela mettra fin à l'encan et à toute possibilité de négocier avec les deux premiers enchérisseurs.",
  'list.modal.pending.moveToLost.confirm.confirm': 'PASSER EN MODE PERDU',
  'list.modal.pending.moveToLost.confirm.success':
    'La voiture a été envoyée à Perdu.',
  'list.modal.pending.moveToLost.confirm.error':
    'Un problème est survenu au moment de passé le véhicule au mode Perdu',
  'list.header.sell.closing.subheading':
    'Vous avez donné aux deux premiers enchérisseurs une seconde chance de faire une offre gagnante sur ces véhicules.',
  'list.header.buy.pending.negotiations.heading':
    'En négociation | Valeur totale négociée {totalBid}',
  'list.header.sell.pending.negotiations.heading':
    'En négociation | Valeur totale négociée {totalBid}',
  'list.header.buy.pending.negotiations.subheading':
    "Les négociations infructueuses déplaceront l'enchère vers Perdu.",
  'list.header.buy.closing.subheading':
    "L'encan se poursuit pour les deux premiers enchérisseurs. C'est votre chance de faire la meilleure offre.",
  'list.header.buy.closing.outbid.heading':
    'Surenchèri | {totalBid} valeur totale',
  'list.header.buy.closing.highbid.heading':
    '1e offre | {totalBid} valeur totale',

  'list.footer.buy.upcoming': 'Fin des véhicules sous À venir',
  'list.footer.buy.upcoming.filtered':
    'Fin de {tradeCount} résultats correspondants sous À venir',
  'list.footer.buy.active': 'Fin des véhicules sous Actif',
  'list.footer.buy.active.filtered':
    'Fin de {tradeCount} résultats correspondants sous Actif',
  'list.footer.buy.looking': 'Vous cherchez plus de véhicules ?',

  'list.footer.buy.looking.pending':
    'Vous cherchez plus de véhicules? Peut-être sont-ils en Fermeture ou sous Arrivé ?',
  'list.footer.buy.looking.dmp.pending':
    'Vous cherchez plus de véhicules? Peut-être sont-ils en Fermeture ou sous Achats ?',
  'list.footer.buy.pending': 'Fin des véhicules sous En Attente',
  'list.footer.buy.pending.filtered':
    'Fin de {tradeCount} résultats correspondants sous En Attente',
  'list.footer.buy.looking.closing':
    "Vous cherchez d'autres véhicules ? Ils pourraient se trouver sous Gagné ou Arrivé",
  'list.footer.buy.closing': 'Fin des véhicules en mode Fermeture',
  'list.footer.buy.closing.filtered':
    'Fin des {tradeCount} résultats correspondants en mode Fermeture',

  'list.footer.sell.looking.pending':
    'Vous cherchez plus de véhicules? Peut-être sont-ils en Fermeture ou sous Arrivé ?',

  'list.footer.see.in': 'Voir ce qui est dans {tradeState}',
  'list.footer.see.in.filtered': 'Vérifier les résultats dans {tradeState}',
  'list.footer.button.backToDashboard': 'Retour Tableau de Bord',
  'list.footer.label.paymentsOnHold':
    'Fin des véhicules avec paiements en suspens',
  'list.empty.content':
    "Essayez moins de filtres ou d'autres filtres pour voir plus de véhicules.",
  'list.empty.buy.pending.decision.header':
    "Il n'y a pas de véhicules qui ont besoin d'une décision.",
  'list.empty.pending.decision.content':
    "Les véhicules qui n'atteignent pas leur prix plancher dans l'Enchère active seront déplacés vers En attente.",
  'list.empty.pending.negotiations.header':
    "Il n'y a pas de véhicule en cours de négociation en ce moment.",
  'list.empty.buy.pending.negotiations.content':
    'Vous pouvez commencer une négociation avec le vendeur dans En attente : En attente de la décision du vendeur.',
  'list.empty.sell.pending.decision.header':
    "Il n'y a pas de véhicules qui ont besoin d'une décision.",
  'list.empty.sell.pending.negotiations.content':
    "Vous pouvez démarrer une négociation avec le meilleur enchérisseur dans En attente : Besoin d'une décision.",
  'list.empty.closing.outbid.header':
    "Il n'y a aucun véhicule en mode Fermeture. - surenchèri",
  'list.empty.closing.outbid.content':
    'Enchérir sur des véhicules en mode Actif.',
  'list.empty.closing.highbid.header':
    "Il n'y a aucun véhicule en mode Fermeture. - 1e offre.",
  'list.empty.closing.highbid.content':
    'Enchérir sur des véhicules en mode Actif.',

  'list.filter.results': 'résultats',
  'list.filter.matching': 'correspondant',
  'list.filter.matchingAll': 'correspondant à vos filtres',
  'list.filter.clear': 'EFFACER VOS FILTRES',

  'list.modal.pending.openNetwork.park.confirm.title':
    'Garer un échange de réseau ouvert',
  'list.modal.dgn.park.error.title': "Impossible de garer l'échange",
  'list.modal.dgn.park.error.message':
    'Vous ne pouvez pas Garer un échange en réseau de groupe de concessionnaires. Si vous souhaitez relancer ou modifier cet échange, vous pouvez Garer la version réseau ouvert de cet échange.',
  'list.modal.open.park.error.title':
    'Vous ne pouvez pas bloquer la transaction à réseau ouvert',
  'list.modal.open.park.error.message':
    'Vous ne pouvez pas bloquer la version réseau ouvert de cette transaction alors que la transaction du réseau du groupe de concessionaires est toujours en mode Enchère active.',
  'list.modal.edit.error.title': "Impossible de modifier l'échange",
  'list.modal.edit.error.message':
    'Vous ne pouvez pas modifier un échange de réseau ouvert ou de réseau de groupe de concessionnaires.',
  'list.modal.dgn.markLost.message':
    'Cela mettra fin à cette enchère en réseau du groupe de concessionnaires et à toute possibilité de la négocier. La version réseau ouvert de ce véhicule sera toujours disponible.',
  'list.modal.open.markLost.message':
    'Cela mettra fin à cette enchère en réseau ouvert et à toute possibilité de la négocier. La version réseau du groupe de concessionnaires de ce véhicule sera toujours en enchère.',
  'list.modal.pending.openNetwork.park.confirm.message':
    'Lorsque vous Garez cet échange, la version du réseau de groupe de concessionnaires de cet échange sera déplacée vers Perdu.',
  'list.openTrade.dgn.negotiate.error.title':
    'Vous ne pouvez pas encore négocier',
  'list.openTrade.dgnActive.negotiate.error.message':
    "La version réseau du groupe de Concessionnaires de cet échange est toujours dans l'enchère Active. Vous ne pouvez négocier que lorsque les deux échanges sont En attente.",
  'list.openTrade.dgn.negotiateFirst.error.message':
    "Vous devez d'abord négocier sur le réseau d'échange du groupe de concessionnaires. Si vous ne voulez pas négocier, marquez-le comme Perdu. Lorsque la version du réseau de groupe de concessionnaires de cet échange est marquée Perdue, vous pourrez négocier sur cet échange.",
  'list.openTrade.dgn.negotiate.error.message':
    "Vous négociez actuellement sur la version réseau du groupe de concessionnaires de ce véhicule. Refusez cette négociation si vous souhaitez négocier sur l'échange en réseau ouvert.",

  'list.openTrade.close.message.error':
    'Vous ne pouvez pas conclure cette transaction tant que la version réseau du groupe de concessionnaires est en cours de négociation. Si vous voulez toujours la marquer Fermer, alors marquez la version du réseau de concessionnaires Perdu pour continuer.',
  'list.openTrade.close.title.error':
    'Impossible de placer ce véhicule de Réseau Ouvert en mode Fermeture pour le moment.',

  // Grid
  'grid.selected': 'SÉLECTIONNÉS',

  // Card
  'list.card.distance.over': 'Plus de {distance}',
  'list.card.distance.within': 'À moins de {distance}',
  'list.card.negotiation.proposals.buyer': 'Acheteur',
  'list.card.negotiation.proposals.you': 'Vous',
  'list.card.negotiation.start': 'Négocier',
  'list.card.negotiation.view': 'Visualiser',
  'list.card.negotiation.reply': 'Répondre',
  'list.card.negotiation.sendClosing': 'Envoyer en Fermeture',
  'list.card.negotiation.yourTopBid': 'Votre meilleure offre ',
  'list.card.negotiation.topBid': 'Meilleure offre',

  // Card DGN
  'list.card.dgn.network': 'Réseau {networkName}',
  'list.card.dgn.pending.network': '{networkName} (Dupliqué en Réseau Ouvert)',

  // TRD
  'trd.description': 'Transport direct',
  'trd.tooltip':
    'Le vendeur a choisi d’utiliser le Transport Direct exclusivement. Voir les informations sur les tarifs.',
  'trd.tooltip.promo':
    'Le vendeur a choisi d’utiliser le Transport Direct exclusivement. Voir les informations promotionnelles.',

  // Notifications
  'notifications.alerts': 'Alertes',
  'notifications.alerts.none': 'Aucune alertes.',
  'notifications.alerts.error':
    'Une erreur a été rencontrée lors de la récupération des alertes, veuillez réessayer.',
  'notifications.todos': 'Liste de tâches',
  'notifications.todos.none': 'Aucune tâche dans votre liste.',
  'notifications.todos.error':
    'Une erreur a été rencontrée lors de la récupération de la liste des tâches, veuillez réessayer.',

  // Dealer badges on Nav bar
  'dealerBades.nav.tooltip.1': "L'un des vendeurs les plus importants",

  // Shared Badges Tooltips
  'sharedBadges.tooltip.1': 'Vous êtes un vendeur de volume',

  // TIAH Landing Page
  'tiah.landing.header.heading':
    "Obtenez-en plus pour votre véhicule d'échange avec TradeRev.",
  'tiah.landing.header.subheading':
    "Sans problème, sans négociation ni engagement. Il suffit de s'asseoir et de regarder des milliers de concessionnaires faire une offre instantanée sur votre véhicule.",
  'tiah.landing.header.form.placeholder':
    'Saisissez votre ville ou votre code postal',
  'tiah.landing.header.form.findDealers': 'TROUVER UN CONCESSIONNAIRE',
  'tiah.landing.purpose.heading': 'COMMENT TRADEREV FONCTIONNE-T-IL?',
  'tiah.landing.purpose.subheading':
    "Nos concessionnaires se font concurrence pour acheter <i>votre</i> véhicule d'échange, vous donnant plus d'argent à investir dans votre nouveau véhicule.",
  'tiah.landing.purpose.content':
    "Nous étions, au départ, un encan pour les véhicules d'occasion réservé aux concessionnaires. Maintenant, au lieu de ne recevoir qu'une seule offre pour votre véhicule d'échange, vous pouvez exploiter le pouvoir d'achat du réseau de ce même concessionnaire pour obtenir plus d'argent pour votre véhicule.",
  'tiah.landing.stepone.heading': 'ÉTAPE UN',
  'tiah.landing.stepone.subheading':
    'Choisissez le concessionnaire où vous aimeriez acheter votre prochain véhicule.',
  'tiah.landing.stepone.content':
    'TradeRev est partenaire de la plupart des concessionnaires au Canada. Cela signifie que vous trouverez toujours un concessionnaire près de chez vous pour échanger ou acheter.',
  'tiah.landing.steptwo.heading': 'ÉTAPE DEUX',
  'tiah.landing.steptwo.subheading': 'Parlez-nous de votre échange.',
  'tiah.landing.steptwo.content':
    "Nous enverrons vos coordonnées au concessionnaire de votre choix, qui vous contactera pour discuter de l'achat de votre nouveau véhicule et de votre véhicule d'échange. Vous pourrez alors effectuer le reste du processus depuis votre domicile et ne vous rendre chez le concessionnaire que si vous décidez de finaliser la transaction.",
  'tiah.landing.stepthree.heading': 'ÉTAPE TROIS',
  'tiah.landing.stepthree.subheading': 'Regarder les offres affluer.',
  'tiah.landing.stepthree.content':
    "Plus de « Laissez-moi parler à mon directeur ». Détendez-vous pendant que votre véhicule d'échange est mis aux enchères auprès de nos concessionnaires. Ils se mettront en concurrence pour acheter votre véhicule d'échange, et vous déciderez si l'offre finale vous convient. ",
  'tiah.landing.stepthree.content.hyperlink':
    '(moyennant des frais de service). ',
  'tiah.landing.stepthree.content.parttwo': "Ce n'est pas obligatoire.",
  'tiah.landing.getStartedNow': 'COMMENCEZ MAINTENANT!',
  'tiah.landing.benefits.overview.heading': 'TRADEREV VS. LA COMPÉTITION',
  'tiah.landing.benefits.overview.subheading':
    "Ce n'est même pas un combat équitable.",
  'tiah.landing.benefitOne.subheading': 'Plus de va-et-vient.',
  'tiah.landing.benefitOne.content':
    "Les concessionnaires partenaires de TradeRev mettent aux enchères votre échange dans notre réseau pancanadien afin de maximiser la valeur de vos véhicules. Vous recevrez une évaluation claire sans qu'aucune négociation ne soit nécessaire.",
  'tiah.landing.benefitTwo.subheading': 'Gagnez du temps et évitez les tracas.',
  'tiah.landing.benefitTwo.content':
    'Les contrôles de sécurité, les formalités administratives, le nettoyage, la mise en ligne de votre ancien véhicule, les réponses aux appels et aux courriels, et le pire, le marchandage avec des inconnus. Passez tout avec TradeRev.',
  'tiah.landing.benefitThree.subheading':
    'Maximiser les économies sur les taxes.',
  'tiah.landing.benefitThree.content':
    "En échangeant votre véhicule auprès d'un concessionnaire, vous économiserez des taxes que vous pourrez affecter à l'achat de votre nouveau véhicule.",
  'tiah.landing.marketing.mainHeading': "QU'EST-CE QUE TRADEREV?",
  'tiah.landing.marketing.heading':
    'Nous avons révolutionné toute une industrie. Pas de problème.',
  'tiah.landing.marketing.subheading':
    'Il y a près de dix ans, nous avons uniformisé les règles du jeu pour les concessionnaires.',
  'tiah.landing.marketing.content':
    "Nous avons créé un marché numérique de premier plan pour les concesssionnaires qui achètent et vendent des véhicules en ligne fondé sur la confiance et le choix. Aujourd'hui, les concessionnaires du Canada vendent des milliers de véhicules chaque semaine sur TradeRev.",
  'tiah.landing.marketing.subtext':
    'Désormais, vous le pouvez aussi - sans engagement.',
  'tiah.landing.marketing.statOne': 'Plus de 5 000 concessionnaires',
  'tiah.landing.marketing.statOne.content':
    "de notre réseau veulent votre véhicule d'échange.",
  'tiah.landing.marketing.statTwo':
    'Plus de 2 milliards de dollars de véhicules vendus',
  'tiah.landing.marketing.statTwo.content':
    'chaque année au Canada sur TradeRev',
  'tiah.landing.FAQ.heading': 'QUESTIONS FRÉQUENTES',
  'tiah.landing.FAQ.subheading':
    'Oui, nous sommes vraiment aussi bons que cela!',
  'tiah.landing.FAQ.one.question': "Qui va acheter mon véhicule d'échange?",
  'tiah.landing.FAQ.one.answer':
    "Les concessionnaires automobiles. Lorsque vous lancez le véhicule  d'échange sur notre plateforme de vente aux enchères numérique, notre réseau de plus de 5 000 concessionnaires acheteurs a la possibilité de faire des offres et d'acheter votre véhicule.",
  'tiah.landing.FAQ.two.question':
    "Que faire si mon véhicule d'échange n'est pas parfait?",
  'tiah.landing.FAQ.two.answer':
    "Aucun véhicule n'est parfait, n'est-ce-pas? Vous aurez donc l'occasion de montrer des photos de l'usure ou des dommages de votre véhicule d'échange. Les concessionnaires sont des professionnels du secteur qui savent qu'un véhicule d'échange comporte des imperfections.",
  'tiah.landing.FAQ.three.question':
    "Que se passe-t-il si mon véhicule d'échange a eu un accident?",
  'tiah.landing.FAQ.three.answer':
    "C'est bon! Les concessionnaires ont l'habitude d'acheter et de vendre des véhicules déjà accidentés. C'est tout à fait normal. Notre système vérifiera l'historique de votre véhicule à partir de diverses sources et informera automatiquement nos acheteurs de tout historique d'accident.",
  'tiah.landing.FAQ.four.question':
    "Mon véhicule d'échange est loué ou financé - puis-je encore utiliser TradeRev?",
  'tiah.landing.FAQ.four.answer':
    "Oui ! Contrairement à la vente à un acheteur privé, les concessionnaires ont l'habitude de traiter avec les sociétés de crédit-bail et de financement et peuvent s'occuper des formalités administratives pour vous. Voici une excellente raison d'effectuer l'échange de votre véhicule avec TradeRev!",
  'tiah.landing.FAQ.five.question':
    'Faut-il payer pour utiliser la fonction Échange à Domicile?',
  'tiah.landing.FAQ.five.answer':
    "Après la vente aux enchères, si vous décidez d'accepter l'offre et de vendre votre véhicule, des frais de service seront déduits de la valeur de votre échange par le concessionnaire. Les frais varient en fonction de la valeur de l'échange final et seront indiqués dans le courriel qui vous sera envoyé à la fin de votre enchère. {breakingLine}{breakingLine} Vous pouvez consulter les frais de service ici : ",
  'tiah.landing.FAQ.five.answer.auction.price': "Prix de l'enchère",
  'tiah.landing.FAQ.five.answer.service.fee': 'Frais de service',
  'tiah.landing.FAQ.five.answer.less': 'ou moins',
  'tiah.landing.FAQ.five.answer.more': 'ou plus',
  'tiah.landing.FAQ.six.question':
    "Que faire si mon véhicule d'échange est modifié?",
  'tiah.landing.FAQ.six.answer':
    "C'est bien. Lorsque vous inspectez votre véhicule et envoyez les informations au concessionnaire, veillez à lui signaler toute modification (suspension, échappement, carrosserie). N'oubliez pas non plus de mentionner toute amélioration, comme les barres de toit ou les pneus d'hiver, car dans la plupart des cas, ces éléments vous permettront d'obtenir un meilleur prix pour votre véhicule d'échange !",
  'tiah.landing.FAQ.seven.question':
    'Puis-je échanger une voiture de collection?',
  'tiah.landing.FAQ.seven.answer':
    "Oui. Bien que l'audience puisse être de niche, il y a souvent des concessionnaires dans notre réseau national qui recherchent des véhicules très spécifiques, y compris des voitures classiques.",
  'tiah.landing.FAQ.eight.question':
    'Et si je ne sais pas encore quel véhicule neuf je veux acheter?',
  'tiah.landing.FAQ.eight.answer':
    "L'achat d'un véhicule peut être à la fois stressant et effrayant. Les concessionnaires sont une excellente solution pour vous aider à faire un choix éclairé. Mais avec certains concessionnaires, vous pouvez ressentir une pression lorsque vous discutez avec eux pour accepter les offres. {breakingLine}{breakingLine} Vous pouvez utiliser TradeRev pour entamer la conversation avec un concessionnaire sans pression. Ils peuvent utiliser TradeRev pour vous obtenir une offre sans engagement sur votre échange, et savoir combien d'argent vous obtiendrez peut vous aider à décider de la marque ou du modèle à choisir.",
  'tiah.copyright':
    'Tous droits réservés © {year}. TradeRev® est une marque de commerce de NthGen Software®. Tous droits réservés.',
  'tiah.landing.error.invalid.address':
    'Impossible de trouver l’emplacement que vous avez saisi. Essayez un code postal ou un nom de ville',
  'tiah.landing.legal.privacy.policy': 'Politique de confidentialité',
  'tiah.landing.legal.privacy.policy.url':
    'https://www.traderev.com/en-us/privacy-policy/',
  'tiah.landing.legal.statement': 'Mention légale',

  // TIAH
  'tiah.continue': 'Continuer',

  // TIAH Mobile Phone Number
  'tiah.phone.title': 'Numéro de téléphone cellulaire',
  'tiah.phone.heading':
    'Génial ! Nous allons maintenant confirmer votre numéro de cellulaire.',
  'tiah.phone.subheading':
    "Nous vous enverrons un code par SMS que vous saisirez dans le prochain écran. Nous utiliserons ce téléphone pour rester en communication afin de disccuter de votre véhicule d'échange.",
  'tiah.phone.placeholder': 'ex. 905-123-4567',
  'tiah.phone.error':
    'Cela ne semble pas être un numéro valide. Veuillez vérifier et essayez à nouveau.',

  // TIAH Confirmation Number
  'tiah.confirmation.title': 'Numéro de confirmation',
  'tiah.confirmation.heading':
    'Saisissez le numéro de confirmation que nous venons de vous envoyer.',
  'tiah.confirmation.label': 'Numéro de confirmation à 4 chiffres',
  'tiah.confirmation.missing': "Hmm ... Je n'ai pas reçu le code.",
  'tiah.confirmation.error':
    'Le numéro que vous avez saisi ne correspond pas. Veuillez vérifier et essayez à nouveau.',

  // TIAH Dealer Map
  'tiah.map.title': 'Carte des concessionnaires',
  'tiah.map.wrapper.title':
    'Choisissez le concessionnaire où vous voulez acheter votre prochain véhicule.',
  'tiah.map.filter.title': 'Filtrez les concessionnaires',
  'tiah.map.filter.question1': 'Est-ce que vous avez un véhicule à échanger ?',
  'tiah.map.filter.yes': 'Oui',
  'tiah.map.filter.no': 'Non',
  'tiah.map.filter.question2':
    'Vous cherchez à acheter un véhicule neuf ou d`occasion ?',
  'tiah.map.filter.new': 'Neuf',
  'tiah.map.filter.used': 'Occasion',
  'tiah.map.filter.notsure': 'Je ne suis pas sûr',
  'tiah.map.filter.make': 'Marque du véhicule neuf',
  'tiah.map.filter.model': 'Modèle',
  'tiah.map.filter.help': 'Comment choisir le bon concessionnaire?',
  'tiah.map.filter.notradein.title':
    "Pour l'instant, TradeRev n'est destiné qu'aux véhicules d`échange.",
  'tiah.map.filter.notradein.message':
    "Nous sommes ravis que vous souhaitiez essayer TradeRev ! Cependant, pour le moment, nous concentrons nos activités à d`aider les gens à tirer le meilleur parti de leur véhicule d'échange.",
  'tiah.map.info.valid.traderev': 'S’est associé avec TradeRev',
  'tiah.map.info.button.msg': 'Choisir ce concessionnaire',
  'tiah.map.modal.close': 'FERMER',
  'tiah.map.modal.title':
    'Comment choisir le bon concessionnaire avec qui travailler ?',
  'tiah.map.modal.firstsection':
    "Quel que soit le concessionnaire que vous choisissez, lorsqu`ils vendent votre véhicule d'échange aux enchères avec TradeRev, vous savez que vous obtenez un excellent rapport qualité-prix. Vous n`avez pas besoin de vous en soucier.",
  'tiah.map.modal.listheader':
    'Voici d`autres éléments à prendre en considération lors du choix d`un concessionnaire :',
  'tiah.map.modal.listitem1':
    "Vendent-ils la marque et le modèle du véhicule neuf que vous cherchez à acheter ? N'importe quel concessionnaire peut prendre votre véhicule d'échange, mais seuls certains concessionnaires peuvent avoir le nouveau véhicule que vous souhaitez.",
  'tiah.map.modal.listitem2':
    "Vendent-ils uniquement des véhicules neufs ou d'occasion, ou les deux ? Certains concessionnaires vendent à la fois des véhicules neufs et d'occasion, tandis que d`autres ne vendent que des véhicules d'occasion.",
  'tiah.map.modal.lastsection':
    'Vous pouvez en apprendre beaucoup sur un concessionnaire en visitant son site Web ou en l`appelant rapidement.',
  'tiah.map.error.message':
    'Un problème est survenu lors du traitement de votre demande. Veuillez réessayez.',

  // Negotiation modals
  'modal.negotiation.tutorial.title': 'Comment fonctionnent les négociations',
  'modal.negotiation.tutorial.negotiation.start': 'Entamer la Négociation',
  'modal.negotiation.tutorial.buyer.message0':
    "Si le <b>vendeur répond</b>, il perdra la possibilité de passer ce véhicule en mode Fermeture. Par contre, s'il ne répond pas, il pourra passer en mode Fermeture.",
  'modal.negotiation.tutorial.buyer.message1':
    'Si la négociation aboutit, le véhicule passera dans la section Achats.',
  'modal.negotiation.tutorial.buyer.message2':
    "Si vous ou le vendeur <b>refusez</b> ou si le délai En Attente se termine, le prix négocié le plus bas du vendeur sera proposé en guise d'offre unique au deuxième enchérisseur.",
  'modal.negotiation.tutorial.buyer.message3':
    'Si vous <b>entamez la négociation</b> et que le <b>vendeur la rejette</b>, le véhicule passera à Non Vendu.',
  'modal.negotiation.tutorial.buyer.secondBidder.message0':
    'Le vendeur a tenté en vain de négocier avec le meilleur enchérisseur sur ce véhicule.',
  'modal.negotiation.tutorial.buyer.secondBidder.message1':
    'Le vendeur est prêt à vous vendre ce véhicule au prix négocié le plus bas.',
  'modal.negotiation.tutorial.buyer.secondBidder.message2':
    'Vous pouvez <b>accepter ou refuser</b> ce prix demandé final.',
  'modal.negotiation.tutorial.seller.message0':
    "Si la négociation est concluante, le véhicule passera en mode Gagné ou Arrivé, s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.message1':
    "Si vous ou l'acheteur refusez ou si le délai En Attente se termine, le prix négocié le plus bas du vendeur sera proposé en guise d'offre unique au deuxième enchérisseur.",
  'modal.negotiation.tutorial.seller.message2':
    "<b>Si vous entamez cette négociation, vous perdrez la possibilité d'envoyer ce véhicule en mode Fermeture.</b>",
  'modal.negotiation.tutorial.seller.open.start.message0':
    "Si la négociation aboutit, le véhicule passera à Gagné ou Arrivé s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.open.start.message1':
    "Si vous ou l'acheteur refusez la négociation, ce véhicule en Réseau Ouvert passera en mode Perdu.",
  'modal.negotiation.tutorial.seller.open.start.message2':
    'Si la négociation de ce véhicule en Réseau Ouvert échoue, vous pourrez toujours négocier sur la version Réseau Groupe Concessionnaires.',
  'modal.negotiation.tutorial.seller.dgn.firstReply.message0':
    "Si vous démarrez cette négociation, vous perdrez la possibilité d'envoyer cette enchère à Clôture.",
  'modal.negotiation.tutorial.seller.dgn.firstReply.message1':
    'Si la négociation réussit, le véhicule passera à Gagné ou Arrivé.',
  'modal.negotiation.tutorial.seller.dgn.message1':
    "Si la négociation aboutit, le véhicule passera à Gagné ou Arrivé s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.dgn.message2':
    "Si vous ou l'acheteur refusez la négociation, ce véhicule en Réseau Groupe Concessionnaires passera en mode Perdu.",
  'modal.negotiation.tutorial.seller.dgn.message3':
    'Si cette négociation de ce véhicule en Réseau Groupe Concessionnaires échoue, vous pourrez toujours négocier sur sa version en Réseau Groupe Ouvert.',
  'modal.negotiation.buyer.floorPriceLabel': 'Prix plancher: ',
  'modal.negotiation.noOffers': 'Aucune offre pour le moment.',
  'modal.negotiation.negotiationEnded': 'Les négociations sont terminées.',
  'modal.negotiation.sentToSecondBidder':
    'La dernière offre finale de {price} a été envoyé au deuxième enchérisseur',
  'modal.negotiation.offerAmount': 'Montant de l’offre',
  'modal.negotiation.counterAmount': 'Montant contreproposition',
  'modal.negotiation.tip': 'Astuce: ',
  'modal.negotiation.seller.tip.part1':
    "Envisagez d'utiliser votre prix plancher de ",
  'modal.negotiation.seller.tip.part2': ' comme premier prix demandé.',
  'modal.negotiation.buyer.tip.part1':
    "Envisagez d'utiliser votre procuration de ",
  'modal.negotiation.buyer.tip.part2': ' lors de votre première offre.',
  'modal.negotiation.comment': 'Commentaire',
  'modal.negotiation.optional': 'facultatif',
  'modal.negotiation.minimumBid': 'Minimum {minimumBid}',
  'modal.negotiation.comment.max': '{value} caractères max.',
  'modal.negotiation.error.noValue': 'Veuilez saisir un montant',
  'modal.negotiation.error.lowValue':
    "L'offre que vous avez saisie est trop basse. Saisissez une offre d'au moins {minAmount}.",
  'modal.negotiation.error.wrongIncrement':
    "Le montant n'est pas dans le bon incrément. Veuillez utiliser des incréments de {bidIncrement}.",
  'modal.negotiation.comment.placeholder': 'Commentaire facultatif',
  'modal.negotiation.send': 'Envoyer',
  'modal.negotiation.loading': 'CHARGEMENT',
  'modal.negotiation.newCounter': 'Nouvelle contreproposition',
  'modal.negotiation.accept': 'Accepter',
  'modal.negotiation.accept.secondBidder': 'Accepter {offer}',
  'modal.negotiation.accept.title': "Accepter l'offre {offer} ?",
  'modal.negotiation.accept.description':
    "Cela mettra fin aux négociations et fera passer ce véhicule en mode Gagné ou Arrivé s'il est en inventaire.",
  'modal.negotiation.accept.toHigh.label':
    'Votre contre-offre est supérieure à la dernière offre du vendeur. ',
  'modal.negotiation.counter.greater.floorPrice.message':
    'La dernière offre de l’acheteur pour cette {name} était de {offer}. Vous pouvez soit accepter leur offre de {offer}, soit proposer un montant égal ou inférieur à votre prix plancher de {floorPrice}.',
  'modal.negotiation.counter.greater.floorPrice.label':
    'Votre contre-offre est supérieure à votre prix plancher.',
  'modal.negotiation.accept.toHigh.message':
    'Le vendeur demandait {offer} $ pour ce {name}. Vous pouvez soit accepter cette somme de {offer}, soit soumettre une contre-offre inférieure.',
  'modal.negotiation.accept.toLow.message':
    'L’acheteur avait proposé {offer} pour cette {name} lors de sa dernière offre. Vous pouvez soit accepter cette somme de {offer}, soit soumettre une contre-offre supérieure.',
  'modal.negotiation.accept.toLow.label':
    'Votre contre-offre est inférieure à la dernière offre de l’acheteur. ',
  'modal.negotiation.accept.error': 'Un problème est survenu',
  'modal.negotiation.accepted':
    'La Négociation a été fructueuse, le véhicule est passé en mode {state}.',
  'modal.negotiation.dismiss': 'Rejeter',
  'modal.negotiation.counter': 'Contreposition',
  'modal.negotiation.decline': 'Refusé',
  'modal.negotiation.decline.success': 'Négociation refusée.',
  'modal.negotiation.decline.secondBidder.success':
    'Négociation refusée, dernière offre envoyée au second enchérisseur.',
  'modal.negotiation.buyer.decline.title': 'Refusez {offer} le prix demandé ?',
  'modal.negotiation.buyer.decline.description':
    'Un refus mettra fin à cette encan. Le prix le plus bas demandé par le vendeur sera maintenant proposé au deuxième meilleur offrant.',
  'modal.negotiation.decline.description.secondBidder':
    'This will end this auction.',
  'modal.negotiation.decline.dgn.description':
    'Le refus mettra fin à cette enchère.',
  'modal.negotiation.seller.decline.title': 'Mettre fin à la négociation ?',
  'modal.negotiation.seller.decline.description':
    "Ceci mettra fin à cette négociation. Une dernière demande de {askingPrice} sera faite au deuxième enchérisseur. S'ils n'acceptent pas, ou s'il n'y a pas d'enchérisseur de deuxième place, l'offre sera envoyée à Perdu.",
  'modal.negotiation.buyer.decline.yesDecline': 'Oui, refuser',
  'modal.negotiation.seller.decline.yesDecline': 'Mettre fin à la négociation',
  'modal.negotiation.stayFirm': 'RESTER FERME',
  'modal.negotiation.stayFirm.stayFirmButton': 'rester ferme à {offer}',
  'modal.negotiation.stayFirm.stayFirmLabel': 'Ferme à {offer}',
  'modal.negotiation.decline.seller.title':
    "Refuser la première offre de l'acheteur",
  'modal.negotiation.decline.seller.description.msg1':
    "Vous pouvez refuser l'offre et envoyer ce véhicule à Clôture pour continuer l'enchère avec les deux meilleurs enchérisseurs.",
  'modal.negotiation.decline.seller.description.msg2':
    "Si vous ne souhaitez pas continuer l'enchère, envoyez le véhicule à Perdu.",
  'modal.negotiation.decline.seller.sendToClosing': 'Envoyer en Fermeture',
  'modal.negotiation.decline.seller.sendToLost': 'ENVOYER À PERDU',
  'modal.negotiation.lastBid': 'Dernière mise',
  'modal.negotiation.floorPrice': 'Prix Plancher',
  'modal.negotiation.highBid.message':
    'Votre offre de {amount} semble trop élevée. Souhaitiez-vous saisir une offre de {amount} ? Si tel est le cas, vous pouvez continuer ci-dessous.',
  'modal.negotiation.proxyAmount': "Votre offre maximale dans l'encan",
  'modal.negotiation.offer.today': "'Aujourd`hui à' H 'h' mm",
  'modal.negotiation.offer.yesterday': "'Hier à' H 'h' mm",
  'modal.negotiation.offer.someDay': "do MMM 'à' H 'h' mm",
  'modal.decision.sendToClosing.title':
    'Envoyer le véhicule à l’encan sous Fermeture',
  'modal.decision.sendToClosing.message0':
    'Les deux meilleurs enchérisseurs continueront à soumettre des offres à l’encan sous le mode Fermeture jusqu’à ce qu’il y ait un gagnant. L’offre finale soumise à l’encan sera le prix de vente final.',
  'modal.decision.sendToClosing.cashvalue.label': 'Valeur réelle de rachat',
  'modal.decision.sendToClosing.cashvalue.placeholder': 'Saisir une valeur $',
  'modal.decision.sendToClosing.cashvalue.footer':
    '<b>Noter:</b> La valeur réelle de rachat est utilisée en interne pour vos propres dossiers.',
  'modal.decision.sendToClosing.button.sendToClosing':
    'ENVOYER À L’ENCAN SOUS FERMETURE',
  'modal.decision.sendToClosing.success':
    'Le véhicule a été envoyé en mode Fermeture',
  'modal.decision.sendToClosing.error':
    'Impossible de déplacer le véhicule en mode Fermeture. Essayer à nouveau plus tard.',
  'modal.decision.sendToClosing.message.dgnTrade':
    "Les deux meilleurs enchérisseurs continueront d'enchérir jusqu'à ce qu'il y ait un gagnant. La version Réseau ouvert de cet échange sera envoyée à Perdu.",
  'modal.decision.sendToClosing.message.openTrade':
    "Les deux meilleurs enchérisseurs continueront d'enchérir jusqu'à ce qu'il y ait un gagnant. La version réseau du groupe de concessionnaires de cet échange sera envoyée à Perdu.",
  'negotiation.free.disclaimer':
    'Les négociations sont gratuites. Concluez un accord en entamant une négociation.',
  'negotiation.tip.offer.proxy':
    'Une vente pourrait être conclue!{br}Presentez votre offre maximale (proxy)',
  'negotiation.encourage.modal.heading':
    'Êtes-vous certain de vouloir {actionLabel}?',
  'negotiation.encourage.modal.message':
    "L'encan s'est terminé sans accord,  l'acheteur pourrait par contre être disposé à offrir plus d'argent.{br}Nous vous suggérons d'entamer une négociation avec le plus offrant.",
  'negotiation.send.to.lost': 'Envoyer vers Perdu',
  'negotiation.send.to.closing': 'Envoyer en Fermeture',
  'negotiation.send.to.parked': 'Envoyer vers Stationné',
  'auto.win.on.disclaimer':
    "Gagner automatiquement est activé : Nous utiliserons votre montant par procuration pour essayer de gagner si le prix plancher n'est pas atteint ou lors d'une négociation.",
  'your.proxy': 'Votre offre maximale',
  'okta.redirect.loading': 'Téléchargement en cours...',

  // Payments on Hold
  'paymentsOnHold.totalAmountOnHold': 'Montant total en suspens:',
  'paymentsOnHold.ownershipsOwing': 'Immatriculation requise:',
  'paymentsOnHold.lienReleasesOwing': 'Lettre de quittance:',
  'paymentsOnHold.sort.oldestFirst': 'Plus ancien en tête',
  'paymentsOnHold.sort.newestFirst': 'Plus récent en tête',
  'paymentsOnHold.sort.highestPriceFirst': 'Prix plus élevé en tête',
  'paymentsOnHold.owing': 'En attente',
  'paymentsOnHold.processing': 'En traitement',
  'paymentsOnHold.approvedPrintLabel': 'Accepté (imprimer l’étiquette)',
  'paymentsOnHold.upload': 'Téléversez à nouveau',
  'paymentsOnHold.readyForPickup': 'Prêt pour le ramassage',
  'paymentsOnHold.pickedUp': 'Ramassé',
  'paymentsOnHold.verified': 'Vérifié',
  'paymentsOnHold.lienRelease': 'Lettre de quittance requise',
  'paymentsOnHold.lienRelease.neededForFunding':
    'Lettre de libération requise pour financement',
  'paymentsOnHold.ownership': 'Immatriculation',
  'paymentsOnHold.ownership.neededForFunding':
    'Immatriculation requise pour paiement',
  'paymentsOnHold.emailTo': 'Envoyer courriels à',
  'paymentsOnHold.sendTo': 'Envoyer à:',
  'paymentsOnHold.documentsOwing': 'Documents requis',
  'paymentsOnHold.soldFor': 'Vendu',
  'paymentsOnHold.uploadDocument.uploadOwnership':
    'Téléverser l’immatriculation',
  'paymentsOnHold.uploadDocument.uploadLienRelease':
    'Téléverser la lettre de quittance',
  'paymentsOnHold.uploadDocument.uploadOwnershipForVin':
    'Téléverser l’immatriculation pour {vin}',
  'paymentsOnHold.uploadDocument.uploadLienReleaseForVin':
    'Téléverser la lettre de quittance pour {vin}',
  'paymentsOnHold.uploadDocument.uploadedOwnerships':
    'Documents de propriété téléchargés',
  'paymentsOnHold.uploadDocument.uploadedLienReleases':
    'Documents de libération de privilège téléchargés',
  'paymentsOnHold.uploadDocument.viewOwnership': 'Voir l’immatriculation',
  'paymentsOnHold.uploadDocument.viewLienRelease':
    'Voir la lettre de libération',
  'paymentsOnHold.uploadDocument.reviewOwnership': 'Réviser l’immatriculation',
  'paymentsOnHold.uploadDocument.reviewLienRelease':
    'Réviser la lettre de libération',
  'paymentsOnHold.uploadDocument.empty': 'Vide',
  'paymentsOnHold.uploadDocument.failed':
    'Le téléchargement a échoué. Assurez-vous que le type et la taille du fichier sont corrects et réessayez.',
  'paymentsOnHold.submitDocument.success': 'Documents soumis avec succès',
  'paymentsOnHold.submitDocument.failed':
    "Échec de l'envoi des documents. Veuillez réessayer plus tard.",
  'paymentsOnHold.deleteDocument.success': 'Document supprimé avec succès',
  'paymentsOnHold.deleteDocument.failed': 'Impossible de supprimer le document',
  'paymentsOnHold.deleteDocument.modal.title':
    'Voulez-vous vraiment supprimer ce fichier?',
  'paymentsOnHold.deleteDocument.modal.message':
    'Vous ne pourrez pas recevoir de fonds pour ce véhicule sans les documents requis.',
  'paymentsOnHold.greatNews': 'Bonne nouvelle!',
  'paymentsOnHold.placeholderMessage':
    'Il semble que vous n’ayez pas de véhicules dont les paiements sont en attente.',
  'paymentsOnHold.uploadDocument.lien.allowedFileTypes':
    'PDF, JPG, PNG uniquement.',
  'paymentsOnHold.uploadDocument.title.allowedFileTypes': 'PDF uniquement.',
  'paymentsOnHold.uploadDocument.maxFileSize': 'Taille du fichier Max.: 10 Mo',
  'paymentsOnHold.uploadDocument.ownership.info':
    'Remarques importantes avant de téléverser les documents relatifs aux immatriculations:{br}1.) Lorsque l’acheteur n’est pas un concessionnaire du Québec, l’immatriculation non signée du véhicule doit être au nom du concessionnaire vendeur. (TradeRev doit disposer de votre procuration.){br}2.)  Lorsque l’acheteur est un concessionnaire du Québec, l’immatriculation du véhicule doit être au nom du concessionnaire acheteur.',
  'paymentsOnHold.uploadDocument.dragAndDrop':
    'Vous pouvez faire glisser et déposer plusieurs fichiers ici ou',
  'paymentsOnHold.uploadDocument.browse': 'rechercher',

  // TradeStates
  'tradeState.active': 'Actif',
  'tradeState.upcoming': 'À Venir',
  'tradeState.pending': 'En attente',
  'tradeState.closing': 'Fermeture',
  'tradeState.purchase': 'Achats',
  'tradeState.won': 'Gagné',
  'tradeState.arrived': 'Arrivé',
  'tradeState.delivered': 'Livré',
  'tradeState.lost': 'Perdidas',
  'tradeState.parked': 'Stationné',
  'tradeState.consigned': 'Simulcast',
  'tradeState.won.omp': 'Vendu',
  'tradeState.arrived.omp': 'Reçu',
  'tradeState.delivered.omp': 'Récupéré',
  'tradeState.lost.omp': 'Non Vendu',
  'tradeState.parked.omp': 'Stationné',
  'tradeState.active.omp': 'Actif',
  'tradeState.upcoming.omp': 'À Venir',
  'tradeState.pending.omp': 'En attente',
  'tradeState.closing.omp': 'Fermeture',
  'tradeState.purchase.omp': 'Achats',
  'tradeState.consigned.omp': 'Simulcast',

  // Auto Win Setting
  'autowin.setting.bid.settings': 'PARAMÈTRES DES OFFRES',
  'autowin.setting.auto.win': 'Auto-Gagnant',
  'autowin.setting.description':
    'La fonction Auto-Gagnant soumettra une offre en votre nom vous permettant de remporter des véhicules dans certaines situations où vous êtes l’enchérisseur le plus offrant.',
  'autowin.setting.unmet.floor.price.ends':
    'Si une enchère avec un prix plancher non atteint se termine ;',
  'autowin.setting.proxy.bid':
    'et que vous êtes le meilleur enchérisseur avec une offre par procuration supérieure au prix plancher du vendeur, vous remporterez automatiquement le véhicule pour le montant du prix plancher.',
  'autowin.setting.negotiation': 'Si une enchère est négociée ;',
  'autowin.setting.seller.first.offer':
    'et que votre procuration est supérieure à la première offre du vendeur, vous remportez automatiquement le véhicule pour le montant de la première offre du vendeur.',
  'autowin.setting.enable.auto.win': 'Activer Auto-Gagnant',
  'autowin.setting.save': 'Sauvegarder',
  'autowin.setting.enabled': 'Vous avez maintenant activé Auto-Win !',
  'autowin.setting.disabled': 'Vous avez maintenant désactivé Auto-Win !',
  'autowin.setting.unmet.floor.price.ends.rebrand':
    'Si un encan dont vous êtes l’enchérisseur le plus offrant se termine avec un prix plancher non atteint et que votre mise par procuration (proxy) est supérieure au prix plancher du vendeur, vous remporterez automatiquement le véhicule pour le montant du prix plancher du vendeur.',
  'autowin.setting.seller.first.offer.rebrand':
    'Si un encan pour lequel vous êtes l’enchérisseur le plus offrant fait l’objet d’une négociation et que votre mise par procuration (proxy) est supérieure à la première offre du vendeur, vous remporterez automatiquement le véhicule pour le montant de la première offre du vendeur.',
  'autowin.settings.how.it.works': 'En voici le fonctionnement:',
  'autowin.setting.or': 'OU',

  // Retail Tools Setting
  'retail.tools.setting': 'Outils pour vente au détail',
  'retail.tools.setting.description':
    "Ajout/mise à jour du contenu personnalisé de votre concessionnaire visible par vos clients, lorsqu'ils utilisent les liens rapides générés pour l'Échange à Domicile (EaD) et la PdV pour la vente au détail",
  'retail.tools.setting.heading': 'Renseignements du concessionnaire',
  'retail.tools.setting.heading.description':
    'La modification des paramètres ici mettra également à jour tous les liens précédemment générés par ce concessionnaire.',
  'retail.tools.setting.upload.logo': 'Téléverser le logo',
  'retail.tools.setting.upload.logo.for': 'Téléverser le logo pour',
  'retail.tools.setting.edit.logo': 'Modifier le logo',
  'retail.tools.setting.edit.logo.for': 'Modifier le logo pour',
  'retail.tools.setting.upload.logo.description':
    "Le logo du concessionnaire apparaîtra pour votre clientèle sur la page de destination de l'Inspection.",
  'retail.tools.setting.upload.logo.error': 'Un problème est survenu.',
  'retail.tools.setting.logo.note':
    '<b>REMARQUE :</b> les images seront acceptées en format .PNG/.JPEG, de préférence avec un fond transparent.',
  'retail.tools.setting.logo.size':
    'Les images doivent avoir un minimum de 500 x 500 pixels et moins de 15 Mo.',
  'retail.tools.setting.tiah.heading': "Page de renvoi de l'Échange à Domicile",
  'retail.tools.setting.tiah.heading.for':
    'Page d’accueil de l’Inspection au Détail pour',
  'retail.tools.setting.tiah.description':
    "Cette page est celle que les clients voient en premier lorsqu'ils ouvrent le lien de l'Échange à Domicile envoyé par votre concessionnaire :",
  'retail.tools.setting.retailVdp.heading':
    'Info sur le rapport de condition au détail',
  'retail.tools.setting.retailVdp.heading.for':
    'Informations pour le rapport de condition au détail',
  'retail.tools.setting.retailVdp.description':
    'Les informations suivantes apparaitront lorsque vous génèrerez un lien PDV Client:',
  'retail.tools.setting.retailVdp.inventory.disclaimer':
    "Si le client n'est pas intéressé par le véhicule que vous lui proposez, nous lui indiquerons un lien vers votre inventaire de véhicules d'occasion.",
  'retail.tools.setting.warning': 'Avertissement',
  'retail.tools.setting.logo.upload.error':
    'L’image que vous avez essayé de téléverser ne répond pas aux exigences. Essayez à nouveau.',
  'retail.tools.setting.warning.message':
    "La mise à jour des paramètres de ce modèle modifiera également l'apparence et les paramètres de tous les liens précédemment générés à partir de ce compte.",
  'retail.tools.setting.confirmation':
    'Vos configurations ont été sauvegardées. Les mises à jour sont maintenant en temps réel sous vos outils de vente au détail!'
};
